<template>
  <div class="row mt-4 mb-4">
    <div class="col-md-12 p-4 border">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="mdi mdi-calendar-clock"></i> Solicitações de Agendamentos</h4>
        <div>
          <button
            class="btn active btn-outline-secondary btn-sm no-print"
            title="Fechar"
            @click="$emit('voltar')"
          >
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </div>

      <div class="col-md-12 mt-4" v-if="agendamentos && agendamentos.length > 0">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Data e Hora</th>
              <th>Status</th>
              <th>Atualização</th>
              <th class="no-print"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in agendamentos" :key="item.id">
              <td>
                <span v-if="item.data_prevista">
                  {{ item.data_prevista | formatDate }} -
                  {{ item.hora_prevista | formatHora }}
                </span>
                <span v-else> Aguardando Data e Hora </span>
              </td>
              <td>
                <b-badge pill variant="warning" v-if="item.status == 0"
                  >Aguardando</b-badge
                >
                <b-badge pill variant="success" v-else-if="item.status == 1"
                  >Agendado</b-badge
                >
                <b-badge pill variant="secondary" v-else-if="item.status == 2"
                  >Cancelado</b-badge
                >
              </td>
              <td>
                {{ item.updated_at | formatDateHora }}
              </td>
              <td class="no-print">
                <button
                  class="px-2 mb-0 btn btn-sm btn-success"
                  v-if="$store.state.user.id != item.user_id"
                  @click="agendamento = item"
                  v-b-modal.edit-agendamento
                >
                  <i class="mdi mdi-square-edit-outline" />
                </button>
                <button
                  class="px-2 mb-0 btn btn-sm btn-primary"
                  v-else
                  @click="agendamento = item"
                  v-b-modal.ver-agendamento
                >
                  <i class="mdi mdi-eye" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12" v-else>
        <div class="alert alert-info" v-if="add == false">
          Nenhuma agendamento realizado deseja fazer uma solicitação?
          <a class="router-link-exact-active active d-block" @click="add = true">
            <i class="mdi mdi-calendar-clock"></i>
            Solicitar Agendamento
          </a>
        </div>

        <div class="row" v-else-if="add">
          <!-- Formulário de cadastro de solicitação -->
          <FormAgenda :agendamento.sync="agendamento" />

          <div class="col-md-12 d-flex justify-content-end">
            <button
              class="btn btn-success btn-submit-agendamento"
              data-style="zoom-in"
              type="submit"
              @click="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="edit-agendamento"
      centered
      hide-footer
      title="Gerenciar Solicitação de Agendamento"
    >
      <!-- Formulário de cadastro de solicitação -->
      <FormAgenda :agendamento.sync="agendamento" />

      <div class="row">
        <form-select
          v-model="agendamento.status"
          label="Status"
          grid="12"
          :itens="status"
        />

        <form-textarea
          v-model="agendamento.motivo"
          v-if="agendamento.status == 2"
          grid="12"
          label="Motivo do Cancelamento"
          id="agendamento-motivo"
        />
      </div>

      <div class="col-md-12 d-flex justify-content-end">
        <button
          class="btn btn-success btn-submit-agendamento"
          data-style="zoom-in"
          type="submit"
          @click="(type = 'edit'), submit()"
        >
          <i class="mdi mdi-content-save" />
          {{ $t("Salvar") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="ver-agendamento"
      centered
      hide-footer
      title="Detalhes da Solicitação de Agendamento"
    >
      <table class="table">
        <tbody>
          <tr>
            <td>
              Data e Hora: <br />
              <span v-if="agendamento.data_prevista">
                {{ agendamento.data_prevista | formatDate }} -
                {{ agendamento.hora_prevista | formatHora }}
              </span>
              <span v-else> Aguardando Data e Hora </span>
            </td>
          </tr>
          <tr>
            <td>
              Descrição:<br />

              {{ agendamento.descricao }}
            </td>
          </tr>
          <tr>
            <td>
              Motivo:<br />
              {{ agendamento.motivo }}
            </td>
          </tr>
          <tr>
            <td>
              Status:<br />
              <b-badge pill variant="warning" v-if="agendamento.status == 0"
                >Aguardando</b-badge
              >
              <b-badge pill variant="success" v-else-if="agendamento.status == 1"
                >Agendado</b-badge
              >
              <b-badge pill variant="secondary" v-else-if="agendamento.status == 2"
                >Cancelado</b-badge
              >
            </td>
          </tr>
          <tr>
            <td>
              Criado em: {{ agendamento.created_at | formatDate }} - Atualizado em:
              {{ agendamento.updated_at | formatDateHora }}
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import FormAgenda from "./form/FormAgenda";
export default {
  props: ["agendamentos"],
  components: {
    FormAgenda,
  },
  data() {
    return {
      add: false,
      agendamento: {},
      type: null,
      status: [
        {
          id: 0,
          value: "AGUARDANDO",
        },
        {
          id: 1,
          value: "AGENDADO",
        },
        {
          id: 2,
          value: "CANCELADO",
        },
      ],
    };
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-agendamento"));
      ladda.start();

      if (this.type == "edit") {
        this.agendamento.type = "edit";

        if (this.agendamento.status == 0) {
          swal.fire({
            title: "Atenção!",
            html: "O status deve ser atualizado para Agendado ou Cancelado!",
            icon: "error",
          });
          ladda.stop();
          return false;
        }
      }
      // Send request
      axios
        .post(
          `api/dashboard/encaminhamentos/${this.$route.params.id}/agendamento`,
          this.agendamento
        )
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$emit("reload");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
